export function level() {
    const playButtons = document.querySelectorAll('.play-button');
    const videoContainer = document.querySelector('.video'); 
    const nextButton = document.querySelector('.nextbutton');
    const prevButton = document.querySelector('.previousbutton'); 
    const exitButton = document.querySelector('.exit'); 
    const videoIntro = document.querySelector('.video-intro'); 
    const videoImage = document.querySelector('.video-image'); 
    const introText = document.querySelector('.intro-text'); 
    const question = document.querySelector('.question-form'); 
    const wrapper = document.querySelector('.intro'); 
    const videoElement = videoContainer.querySelector('video'); 


    playButtons.forEach((playButton) => {
        playButton.addEventListener('click', function() {

         
            videoContainer.classList.toggle('play');
            setTimeout(() => {
                nextButton.classList.add('visible');
            }, 1000);

            if (videoElement.paused) {
                videoElement.play();
                videoElement.setAttribute('controls', 'controls');
            } else {
                videoElement.pause();
            }

            if (isSmallScreen()) {
                videoIntro.style.display = "block";
            }
        });
    });

    nextButton.addEventListener('click', function() {
        videoIntro.classList.toggle('hidden');
        videoImage.classList.toggle('visible');
        introText.classList.toggle('hidden');
        question.classList.toggle('visible');
        wrapper.classList.add('video-watched');
        videoElement.pause();
    });


    prevButton.addEventListener('click', function() {
        console.log('previous');
        videoIntro.classList.toggle('hidden');
        videoImage.classList.toggle('visible');
        introText.classList.toggle('hidden');
        question.classList.toggle('visible');
        wrapper.classList.remove('video-watched');
    });

    exitButton.addEventListener('click', function() {
        videoElement.pause();
        videoIntro.style.display = "none";
    });

    function isSmallScreen() {
        return window.matchMedia("(max-width: 1050px)").matches;
    }

    document.addEventListener('DOMContentLoaded', function() {
        const urlParams = new URLSearchParams(window.location.search);
                if (urlParams.has('action') && urlParams.get('action') === 'again') {
            again();
        }
    });
    
    function again() {
        videoIntro.classList.toggle('hidden');
        videoImage.classList.toggle('visible');
        introText.classList.toggle('hidden');
        question.classList.toggle('visible');
        wrapper.classList.add('video-watched');
        videoElement.pause();
    }
    
}
